<div class="email-content-editor-container" #emailEditorContainer>
  <div class="recipient-list-container flex flex-col">
    <div *ngIf="!isRecipientEditable" class="recipient-list flex flex-row">
      <div *ngFor="let recipient of allRecipients; let i = index"
           (click)="updateRecipientOptions('showCancelButton');$event.stopPropagation()" class="recipient-item">
        <span>{{recipient.firstName}} {{recipient.lastName}}</span>
        <span *ngIf="i !== (recipients.cc.length + (recipients.to? 1 : 0) - 1)">{{','}}&nbsp;</span>
      </div>
      <span *ngIf="allRecipients.length === 0">Recipients</span>
    </div>
    <div *ngIf="isRecipientEditable" class="recipient-editor flex flex-row">
      <span>To</span>
      <div (click)="$event.stopPropagation()" class="email-recipients-suggestion-panel">
        <mat-form-field class="chip-list-form-field w-100-p" appearance="outline">
          <mat-chip-listbox #chipList aria-label="Recipient selection">
            <mat-chip
              *ngIf="recipients.to"
              class="selected-user-chip-list"
              (removed)="remove(recipients.to, 'to')">
              {{recipients.to.firstName}} {{recipients.to.lastName}}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
            <input
              class="user-selection-input"
              placeholder=""
              #selectUserInput
              [formControl]="searchedText"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add($event, 'to')">
          </mat-chip-listbox>
          <mat-autocomplete class="auto-suggestion-list w-30-p" #auto="matAutocomplete"
                            (optionSelected)="selected($event, 'to')">
            <mat-option *ngFor="let suggestedUser of filteredUsers" [value]="suggestedUser">
              {{suggestedUser.firstName}} {{suggestedUser.lastName}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="isRecipientEditable" class="recipient-editor flex flex-row">
      <span>Cc</span>
      <div *ngIf="isRecipientEditable" (click)="$event.stopPropagation()" class="email-recipients-suggestion-panel">
        <mat-form-field class="chip-list-form-field w-100-p" appearance="outline">
          <mat-chip-listbox #chipList aria-label="Recipient selection">
            <mat-chip
              class="selected-user-chip-list"
              *ngFor="let user of recipients.cc"
              (removed)="remove(user, 'cc')">
              {{user.firstName}} {{user.lastName}}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
            <input
              class="user-selection-input"
              placeholder=""
              #selectUserInput
              [formControl]="searchedText"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add($event, 'cc')">
          </mat-chip-listbox>
          <mat-autocomplete class="auto-suggestion-list w-30-p" #auto="matAutocomplete"
                            (optionSelected)="selected($event, 'cc')">
            <mat-option *ngFor="let suggestedUser of filteredUsers" [value]="suggestedUser">
              {{suggestedUser.firstName}} {{suggestedUser.lastName}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </div>


  <div class="text-editor-container">
    <!--    TODO: Don't remove the following line. Need to update it with ckeditor5-->
    <!--    <ckeditor-->
    <!--      [(ngModel)]="ckEditorContent"-->
    <!--      [config]="ckEditorConfig"-->
    <!--      [readonly]="false"-->
    <!--      (change)="onChange($event)"-->
    <!--      (editorChange)="onEditorChange($event)"-->
    <!--      (ready)="onReady($event)"-->
    <!--      (focus)="onFocus($event)"-->
    <!--      (blur)="onBlur($event)"-->
    <!--      (contentDom)="onContentDom($event)"-->
    <!--      (fileUploadRequest)="onFileUploadRequest($event)"-->
    <!--      (fileUploadResponse)="onFileUploadResponse($event)"-->
    <!--      (paste)="onPaste($event)"-->
    <!--      (drop)="onDrop($event)"-->
    <!--      debounce="500">-->
    <!--    </ckeditor>-->
  </div>
  <div *ngIf="isEditorReady" class="reply-mail-footer-toolbar flex flex-row justify-between items-center">
    <div class="flex flex-row justify-start items-center">
      <button (click)="onSend()" mat-button class="action-button" type="button">
        Send
      </button>
    </div>
    <i (click)="discardMailContent()" class="fa-regular fa-trash"></i>
  </div>
</div>

